/* BKS accueil AA — JS commun : révélation au défilement des .bksaa-rv. Idempotent (inclus par chaque section). */
(function () {
  if (window.__bksaa) return;
  window.__bksaa = true;
  var d = document;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;
  var rails = null;
  function show(el) { el.classList.add('bksaa-in'); }
  function prep(el) { if (el.dataset.d) el.style.setProperty('--bksaa-d', el.dataset.d); }
  /* Rails à défilement horizontal. Sous 768 px, `.bksaa-bento`, `.bksaa-gal` et `.bksaa-ways__l`
     passent en `overflow-x` (celui de la communauté, `.bksaa-corail__w`, l'est à toute largeur).
     Ce qui est poussé hors de la boîte du rail est CLIPPÉ : l'observateur intersecte la cible avec
     la boîte de chaque ancêtre défilant AVANT d'y appliquer la fenêtre, donc une tuile posée à
     droite du rail n'entre jamais dans la fenêtre pendant une lecture verticale — elle ne recevrait
     jamais `.bksaa-in` et resterait à `opacity: 0` pour toujours, sans flèche ni barre de défilement
     pour l'annoncer (mesuré à 390 × 844 : sept blocs sur quarante-cinq, dont cinq des sept portes du
     bento et le panneau de note des avis). Élargir `rootMargin` à l'horizontale ne répare PAS ce
     cas : la marge ne s'applique qu'à la racine, jamais au clip d'un ancêtre défilant.
     On observe donc LE RAIL, qui lui est dans le flux vertical, et son entrée en fenêtre révèle tout
     ce qu'il porte. L'échelonnement `--bksaa-d`, posé en style inline par `prep()`, est conservé :
     les tuiles arrivent l'une après l'autre comme ailleurs sur la page. */
  function railDe(el) {
    for (var n = el.parentElement; n && n.nodeType === 1 && n !== d.body; n = n.parentElement) {
      var ox = getComputedStyle(n).overflowX;
      if ((ox === 'auto' || ox === 'scroll') && n.scrollWidth - n.clientWidth > 2) return n;
    }
    return null;
  }
  function revelerDans(rail) {
    rail.querySelectorAll('.bksaa-rv:not(.bksaa-in)').forEach(function (k) { prep(k); show(k); });
  }
  function reveler(cible) {
    if (cible.classList.contains('bksaa-rv')) show(cible);
    if (rails && rails.has(cible)) revelerDans(cible);
  }
  function observe(root) {
    var els = (root || d).querySelectorAll('.bksaa-rv:not(.bksaa-in)');
    els.forEach(prep);
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(show); return; }
    if (!io) {
      rails = new WeakSet();
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (x) { if (x.isIntersecting) { reveler(x.target); io.unobserve(x.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: .05 });
    }
    els.forEach(function (el) {
      var r = railDe(el);
      if (r) { rails.add(r); io.observe(r); } else { io.observe(el); }
    });
  }
  /* Une grille devient un rail (et l'inverse) au franchissement de 768 px : on reprend la mesure
     pour les blocs encore cachés, sans jamais défaire ceux qui sont déjà révélés. `observe()` est
     idempotent — `io.observe` sur une cible déjà observée ne fait rien. */
  var minuteur = null;
  function reprendre() { if (minuteur) clearTimeout(minuteur); minuteur = setTimeout(function () { observe(); }, 200); }
  /* Filet clavier : une tuile de rail reste un `<a>` dans l'ordre de tabulation. Si le focus s'y pose
     avant que son rail soit entré en fenêtre, on révèle d'emblée le bloc et son rail — jamais de
     focus sur un bloc à `opacity: 0`. */
  function auFocus(e) {
    var n = (e.target && e.target.closest) ? e.target.closest('.bksaa-rv:not(.bksaa-in)') : null;
    if (!n) return;
    prep(n); show(n);
    var r = railDe(n);
    if (r) revelerDans(r);
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { observe(); }); else observe();
  d.addEventListener('shopify:section:load', function (e) { observe(e.target); });
  d.addEventListener('focusin', auFocus);
  window.addEventListener('resize', reprendre);
  window.addEventListener('orientationchange', reprendre);
  window.bksaaObserve = observe;
})();
